// Typography variants defined by recipes/typographyRecipes.js (typographyRecipe.intents).
export const TYPOGRAPHY_VARIANTS = Object.freeze([
  "price",
  "priceStrike",
  "priceLarge",
  "priceStrikeLarge",
  "agriCardTitle",
  "agriCardDesc",
  "agriCardPack",
  "metaKey",
  "metaValue",
  "statValue", // theme-new: role alias of emptyStateTitle metrics for media-banner stats
  "sourceNote",
  "helpCardTitle",
  "helpCardBody",
  "callCentreTitle",
  "callCentreMeta",
  "directoryCardTitle",
  "directoryFieldKey",
  "emptyStateTitle",
  "emptyStateDesc",
  "emptyStateCardTitle",
  "emptyStateCardDesc",
  "weatherAlertLabel",
  "weatherAlertTitle",
  "weatherAlertDesc",
  "weatherHeroTemp",
  "confirmDialogTitle",
  "confirmDialogDesc",
  "confirmDialogDetail",
]);

export const TYPOGRAPHY_USE_CASES = Object.freeze({
  price: "Selling price on a compact card row (12 / 700 / 16).",
  priceStrike: "Struck-through MRP under a price (10 / 400 / 14, line-through).",
  priceLarge: "Selling price on a product details page (28 / 700 / 38).",
  priceStrikeLarge: "Struck-through MRP under a details-page price (16 / 400 / 22, line-through).",
  agriCardTitle: "Agri product card title, clamped by the caller (14 / 600 / 20).",
  agriCardDesc: "Agri product card brand · shop line (10 / 500 / 15).",
  agriCardPack: "Agri product card pack-size pill label (12 / 500 / 16).",
  metaKey: "Label in a stacked icon · label · value meta cell, e.g. advisory Date / Period / District (12 / 400 / 18).",
  metaValue: "Value under a metaKey label in a meta cell (12 / 500 / 18).",
  statValue: "Bold stat value under a metaKey label on a media banner, e.g. weather High / Low (14 / 700 / 20).",
  sourceNote: "Data-source attribution line under a section, e.g. \"Source : IMD\" (14 / 600 / 20).",
  helpCardTitle: "Help & Support category card title (20 / 600 / 30).",
  helpCardBody: "Help & Support category card description (16 / 400 / 24).",
  callCentreTitle: "Call-centre card name (16 / 700 / 24).",
  callCentreMeta: "Call-centre card timings line (12 / 500 / 18).",
  directoryCardTitle: "Official-directory person/service card title (24 / 600 / 32).",
  directoryFieldKey: "Official-directory card field label, uppercase (12 / 500 / 16, +0.6px tracking).",
  emptyStateTitle: "Empty-state card heading, e.g. \"No result found!\" (14 / 700 / 20).",
  emptyStateDesc: "Empty-state card supporting line under emptyStateTitle (12 / 400 / 18).",
  emptyStateCardTitle: "Standalone empty-state card heading, e.g. \"No Results Found\" (20 / 600 / 30).",
  emptyStateCardDesc: "Standalone empty-state card supporting line (16 / 500 / 24).",
  weatherAlertLabel: "Weather alert card level label, uppercase, e.g. \"Red Alert — Immediate action required\" (9 / 600 / 9, +0.72px tracking).",
  weatherAlertTitle: "Weather alert card title (13 / 600 / 16.9).",
  weatherAlertDesc: "Weather alert card description under weatherAlertTitle (10.5 / 400 / 15.75).",
  weatherHeroTemp: "Weather hero card current temperature, e.g. \"31°\" (72 / 800 / 1.15).",
  confirmDialogTitle: "Compact confirm dialog title (RewampActionConfirmDialog variant=compact) (20 / 600 / 30).",
  confirmDialogDesc: "Compact confirm dialog description line (14 / 400 / 21).",
  confirmDialogDetail: "Compact confirm dialog detail line, e.g. \"ID : PGR-…\" (14 / 500 / 21).",
});
